import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Stanford Aetna Alliance",
  shortName: "Stanford Aetna Alliance",
  slug: "stanford-aetna-alliance-insurance",
  seoTitle: "Stanford Aetna Alliance TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Stanford Aetna Alliance insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Stanford Aetna Alliance plan in Coral Springs, FL.",
  seoKeywords:
    "Stanford Aetna Alliance TMS coverage, Stanford Aetna TMS therapy, Stanford Aetna Alliance depression treatment Florida, Stanford Aetna mental health benefits Coral Springs FL, Stanford Aetna Alliance SAINT TMS",
  planType: "employer-sponsored health insurance alliance plan (Aetna network)",
  planRegion:
    "Northern California (Stanford University and affiliated employers)",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services through the Aetna provider network",
  planSpecificIntro:
    "The Stanford Aetna Alliance is an employer-sponsored health insurance plan that provides coverage through the Aetna provider network, primarily serving Stanford University employees and affiliated organizations in Northern California. This plan typically includes behavioral health benefits that may cover TMS therapy when medical necessity criteria are met. Because the plan operates through Aetna's network, coverage for TMS, accelerated protocols, and other advanced depression treatments depends on Aetna's medical policies, your specific plan document, and whether the treatment provider is accessible under your plan's network arrangements.",
  officialResourceUrl: "https://www.aetna.com/",
  officialResourceLabel: "Aetna official website",
};

export const StanfordAetnaAllianceInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default StanfordAetnaAllianceInsurance;
